<wiz-vgroup width="100%" height="100%" gap="0">
  <!-- header, boutons de configuration -->
  <wiz-hgroup *ngIf="hasBorders()"
    width="100%"
    height="30px"
    class="widget-header"
    verticalAlign="center"
    [style.backgroundColor]="backgroundColor">

    <!-- <wiz-hgroup *ngIf="configureEnable"> -->
      <!-- edition du titre en mode template & widget choisi -->
      <wiz-icon *ngIf="configureEnable && canUpdateTemplates" (click)="setDisplaySettings()" [style.color]="iconColor" 
      [wizTooltip]="'$.widget.configure.look.$'">edit</wiz-icon>
    <!-- </wiz-hgroup> -->

    <wiz-vgroup width="100%" height="100%" verticalAlign="center">
      <wiz-label
        [wizLabel]="title"
        width="100%"
        [style.color]="fontColor"
        [wizTextBehavior]="'truncate'"
        [wizTooltip]="title"
        class="widget-title-Label"></wiz-label>
    </wiz-vgroup>

    <wiz-hgroup *ngIf="canUpdateTemplates && templatingMode" width="130px" gap="0" horizontalAlign="end">

      <!-- choix de la source (step) -->
      <wiz-icon (click)="configureDataPool()" 
      *ngIf="hasDS" 
      [ngStyle]="{ display: dataEnable ? 'block' : 'none', color: iconColor }" 
      [wizTooltip]="'$.widget.configure.datapool.$'">data-format</wiz-icon>

      <!-- gestion de la conf -->
      <wiz-icon
        (click)="showSettingsPop()" [wizTooltip]="'$.widget.configure.$'"
        [ngStyle]="{
          display: configureEnable ? 'block' : 'none',
          color: iconColor
        }"
        style=" font-size: 20px; cursor: pointer;">settings</wiz-icon>

      <!-- gestion des droits -->
      <wiz-icon (click)="setRights()" *ngIf="configureEnable" 
      [style.color]="iconColor" 
      [wizTooltip]="'$.widget.configure.useraccess.$'">unlock</wiz-icon>

      <!-- gestion des fonctions connect -->
      <wiz-icon (click)="setConnect()" *ngIf="hasDS && configureEnable" 
      [style.color]="iconColor" 
      [wizTooltip]="'$.connect.title.$'">changing-domain</wiz-icon>
      

      <wiz-spacer width="5px"></wiz-spacer>
      <!-- suppression du widget -->
      <wiz-icon
        (click)="remove()"
        [ngStyle]="{
          display: trashEnable ? 'block' : 'none',
          color: iconColor
        }" [wizTooltip]="'$.common.delete.$'"
        >delete</wiz-icon
      >
    </wiz-hgroup>
  </wiz-hgroup>

  <wiz-group width="100%" height="100%" class="gridster-item-content">
  <!-- template vide, boutons de choix du widget -->
  <wiz-hgroup id="templates"  width="100%"  height="100%" [visible]="!currentWidget && templatingMode" >
    <wiz-vgroup id="scroller" width="100%" height="100%" style="overflow: scroll;">
      <wiz-vgroup width="100%" style="flex-flow: row wrap" gap="0" class="widget-type-selector">
        <wiz-icon (click)="setType(gridType)" [style.color]="iconColor" wizTooltip="$.widget.type.grid.$">grid</wiz-icon>
        <wiz-icon (click)="setType(pivotType)" [style.color]="iconColor" wizTooltip="$.widget.type.pivot.$">pivot</wiz-icon>
        <wiz-icon (click)="setType(listType)" [style.color]="iconColor" wizTooltip="$.widget.type.list.$">list</wiz-icon>
        <wiz-icon (click)="setType(chartType)" [style.color]="iconColor" wizTooltip="$.widget.type.chart.$">graphics</wiz-icon>
        <wiz-icon (click)="setType(formType)" [style.color]="iconColor" wizTooltip="$.widget.type.form.$">form</wiz-icon>
        <wiz-icon (click)="setType(calendarType)" [style.color]="iconColor" wizTooltip="$.widget.type.calendar.$">calendar</wiz-icon>
        <wiz-icon (click)="setType(timelineType)" [style.color]="iconColor" wizTooltip="$.widget.type.timeline.$">unity</wiz-icon>
        <wiz-icon (click)="setType(tileType)" [style.color]="iconColor" wizTooltip="$.widget.type.fd-tile.$">view-thumbnail</wiz-icon>

        <wiz-icon (click)="setType(fdGridType)" [style.color]="fdIconColor" wizTooltip="$.widget.type.fd-grid.$">fd-grid</wiz-icon>
        <wiz-icon (click)="setType(fdFormType)" [style.color]="fdIconColor" wizTooltip="$.widget.type.fd-form.$">fd-form</wiz-icon>
        <wiz-icon (click)="setType(fdCalendarType)" [style.color]="fdIconColor" wizTooltip="$.widget.type.fd-calendar.$">fd-calendar</wiz-icon>
        <wiz-icon (click)="setType(fdTimelineType)" [style.color]="fdIconColor" wizTooltip="$.widget.type.fd-timeline.$">unity</wiz-icon>
        <wiz-icon (click)="setType(fdTileType)" [style.color]="fdIconColor" wizTooltip="$.widget.type.fd-tile.$">view-thumbnail</wiz-icon>

        <wiz-icon (click)="setType(freeFormType)" [style.color]="globalconColor" wizTooltip="$.widget.type.free.form.$">form</wiz-icon>
        <wiz-icon (click)="setType(globalFilterType)" [style.color]="globalconColor" wizTooltip="$.widget.type.globalfilter.$">filters</wiz-icon>
        <wiz-icon (click)="setType(generatorType)" [style.color]="globalconColor" wizTooltip="$.widget.type.generator.$">wizeoo</wiz-icon>
      </wiz-vgroup>
    </wiz-vgroup>
    <wiz-spacer width="5px"></wiz-spacer>
  </wiz-hgroup>

    <!-- conteneur du widget -->
    <wiz-vgroup width="100%" height="100%" class="multi-list-content" [visible]="!!currentWidget" [style.backgroundColor]="widgetBackgroundColor"
    [style.borderRadius]="radius" [style.borderColor]="borderColor" style="border-style: solid; border-width: 1;">    
      <ng-container #widgetContainer></ng-container>
    </wiz-vgroup>

  </wiz-group>



  <!-- bottom -->
  <wiz-hgroup *ngIf="!noBorderToutCourt()" width="100%" height="30px" class="widget-botton-container" [style.backgroundColor]="widgetBackgroundColor" style="padding-left: 5px; padding-right: 5px;">
    <wiz-hgroup width="100%" height="100%" verticalAlign="center" class="widget-botton" gap="0">

      <wiz-hgroup #idxZone width="20px" verticalAlign="center" (dblclick)="copyWidget()" style="cursor: pointer;"><!-- zone indice -->
        <wiz-group width="20px" height="20px" horizontalAlign="center" verticalAlign="center">
          <span
            #blockNum
            class="widget-number"
            width="20px"
            height="20px"
          ></span>
          <wiz-label [wizLabel]="indice" class="widget-number-Label" style="pointer-events: none;"></wiz-label>
        </wiz-group>
      </wiz-hgroup>

      <wiz-hgroup #idxSubZone *ngIf="hasLegacy()" gap="0" minWidth="50px" verticalAlign="center" style="margin-left: -2.5px !important; padding-right: 5px;"><!-- zone héritage -->
        <wiz-icon [style.color]="fdIconColor" style="font-size: 18px;">straight-link</wiz-icon>
        <wiz-group *ngFor="let masterIndice of masterIndices" width="24px" height="20px" horizontalAlign="center" verticalAlign="center">
          <span
            #blockMasterNum
            class="widget-number"
            width="20px"
            height="20px"
          ></span>
          <wiz-label [wizLabel]="masterIndice" class="widget-number-Label"></wiz-label>
        </wiz-group>
      </wiz-hgroup>


      <!-- choix du scenario -->
      <wiz-icon *ngIf="showScenIcon" 
      [wizTooltip]="'$.scen.choose.$'" 
      (click)="chooseScen()" 
      [ngStyle]="{
        display: showScenIcon ? 'block' : 'none',
      }"
      style="  font-size: 20px; cursor: pointer;"
      >scenarii</wiz-icon>

      <wiz-hgroup *ngIf="showScenLabel" width="100%" verticalAlign="center"><!-- libellé du scenar -->
        <span
        #blockBack
        [style.backgroundColor]="scenColor"
        width="10px"
        height="10px"
        class="scen-round-mark" 
        ></span>
        <wiz-label
        [wizLabel]="scenLabel"
        [wizTextBehavior]="'truncate'"
        [wizTooltip]="scenLabel"
        ></wiz-label><!-- [style.color]="fontColor" [visible]="showScenLabel"-->
      </wiz-hgroup>   

      <wiz-spacer *ngIf="!showScenLabel" width="100%"></wiz-spacer>

      <wiz-hgroup #hgConnect [visible]="hasConnect" gap="0">
        <ng-container #containerConnect ></ng-container>
      </wiz-hgroup>

      <!-- <wiz-image *ngIf="exportEnableXLS2" [source]="EXCEL" height="30px" width="30px" (click)="exportDatas('excel')" 
      [wizTooltip]="'$.widget.export.excel.$'" [useHandCursor]="true"></wiz-image>
      <wiz-image *ngIf="exportEnablePDF2" [source]="PDF" height="30px" width="30px" (click)="exportDatas('pdf')" 
      [wizTooltip]="'$.widget.export.pdf.$'" [useHandCursor]="true"></wiz-image> -->
      
      
      <!-- screenPDF -->
      <!-- <wiz-icon *ngIf="exportEnable" style="cursor: pointer; font-size: 20px"  (click)="exportDatas('pdf')" [wizTooltip]="'$.widget.export.pdf.$'">upload</wiz-icon>
       -->
      <!-- export Excel en mode tab -->
      <!-- <wiz-icon *ngIf="exportEnable" style="cursor: pointer; font-size: 20px"  (click)="exportDatas('excel')" [wizTooltip]="'$.widget.export.excel.$'">upload</wiz-icon>
       -->
      <!-- suppression en masse des éléments sélectionnés -->
      
      <!-- <wiz-icon *ngIf="massDeleteEnabled" style="cursor: pointer; font-size: 20px"  (click)="deleteDatas()" [wizTooltip]="'$.pivot.delete.lines.title.$'">delete</wiz-icon>
      

      <wiz-icon *ngIf="hasSlave" [wizTooltip]="'$.common.add.$'" tooltipPlacement="right" class="image-back-orange" style="font-size: 16px; cursor: pointer;" 
          (click)="showSlave($event)">add</wiz-icon> -->



      <!-- zone settings en mode tab (user) -->
      <wiz-icon *ngIf="settingsEnable && canUpdateTemplates" (click)="showSettingsPop()" 
      style="cursor: pointer; font-size: 20px" 
      [wizTooltip]="'$.widget.configure.$'">settings</wiz-icon>

    </wiz-hgroup>

  </wiz-hgroup>


</wiz-vgroup>
